export const ThemeBreakpoints = {
  mobile: 400,
  tablet: 640,
  laptop: 1025,
  desktop: 1500,
};
